import { SELECT_RETURN_OPTION, SELECT_RETURN_OPTION_METHOD } from '../../actions/returnOptions';
import {
  RECEIVE_LOCATIONS,
  RECEIVE_STORE_LOCATOR_GEOLOCATION,
  SET_SELECTED_LOCATION,
  SET_SEARCH_VIEW,
  SET_IS_FETCHING_LOCATIONS,
  SET_IS_CONSOLIDATED,
  RECEIVE_STORE_LOCATOR_SELECTION_REQUIRED,
  RECEIVE_CONSOLIDATED_LOCATIONS,
  RECEIVE_SORTED_BY,
  RECEIVE_LOCATION_TAG_SETTINGS,
  RESET_SELECTED_LOCATION,
} from '../../actions/storeLocator';

export const initialState = {
  isSearchView: false,
  isConsolidated: false,
  cachedQueries: {},
  locationsById: {},
  consolidatedLocations: {},
  selectedLocation: {},
  selectionRequired: false,
  postalCode: '',
  country: '',
  sortedBy: '',
  isFetchingLocations: false,
  locationTagSettings: {},
};

export default (
  state = initialState,
  {
    type,
    data: {
      optionId,
      methodKey,
      locations,
      locationIds,
      locationsById,
      selectedLocation,
      postalCode,
      country,
      isSearchView,
      isConsolidated,
      isFetchingLocations,
      selectionRequired,
      sortedBy,
      locationTagSettings,
    } = {},
  } = {},
) => {
  switch (type) {
    case RECEIVE_LOCATIONS:
      return {
        ...state,
        cachedQueries: {
          ...state.cachedQueries,
          [methodKey]: {
            ...state.cachedQueries[methodKey],
            [postalCode]: locationIds,
          },
        },
        locationsById: {
          ...state.locationsById,
          ...locationsById,
        },
      };
    case RECEIVE_CONSOLIDATED_LOCATIONS:
      return {
        ...state,
        consolidatedLocations: {
          ...state.consolidatedLocations,
          [optionId]: {
            ...state.consolidatedLocations[optionId],
            [postalCode]: locations,
          },
        },
      };
    case RECEIVE_STORE_LOCATOR_GEOLOCATION:
      return {
        ...state,
        country,
        postalCode,
        selectedLocation: initialState.selectedLocation,
        sortedBy: initialState.sortedBy,
      };
    case RECEIVE_SORTED_BY:
      return {
        ...state,
        sortedBy,
      };
    case SET_SELECTED_LOCATION:
      return {
        ...state,
        selectedLocation,
      };
    case SET_SEARCH_VIEW:
      return {
        ...state,
        isSearchView,
      };
    case SET_IS_CONSOLIDATED:
      return {
        ...state,
        isConsolidated,
        selectionRequired: isConsolidated,
      };
    case SET_IS_FETCHING_LOCATIONS:
      return {
        ...state,
        isFetchingLocations,
        selectedLocation: initialState.selectedLocation,
      };
    case RECEIVE_STORE_LOCATOR_SELECTION_REQUIRED:
      return {
        ...state,
        selectionRequired,
      };
    case SELECT_RETURN_OPTION:
      return {
        ...state,
        selectedLocation: initialState.selectedLocation,
        sortedBy: initialState.sortedBy,
      };
    case SELECT_RETURN_OPTION_METHOD:
      return {
        ...state,
        selectedLocation: state.isConsolidated
          ? state.selectedLocation
          : initialState.selectedLocation,
      };
    case RECEIVE_LOCATION_TAG_SETTINGS:
      return {
        ...state,
        locationTagSettings,
      };
    case RESET_SELECTED_LOCATION:
      return {
        ...state,
        selectedLocation: initialState.selectedLocation,
        sortedBy: initialState.sortedBy,
      };

    default:
      return state;
  }
};
